import React from 'react';

export default function AboutUsPage() {
	return (
		<div className="h-550 w-1/2">
			{/* 
     */}
			<div />
		</div>
	);
}
